import { render, staticRenderFns } from "./ta_project_details2.vue?vue&type=template&id=41198e50&scoped=true&"
import script from "./ta_project_details2.vue?vue&type=script&lang=js&"
export * from "./ta_project_details2.vue?vue&type=script&lang=js&"
import style0 from "./ta_project_details2.vue?vue&type=style&index=0&id=41198e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41198e50",
  null
  
)

export default component.exports